import React from "react";
import { useDispatch } from "react-redux";
import { Input, Form } from "antd";
import qrActions from "../../../redux/qr/actions";

const { updateQRUser } = qrActions;

const QRUserForm = ({ user, toggleEditModal }) => {
  const dispatch = useDispatch();

  const onRecordChange = (key, event) => {
    if (key) user[key] = event.target.value;
    dispatch(updateQRUser(user));
  };

  return (
    <Form>
      <Form.Item className="qr-user-form-item">
        <span className="qr-user-modal-field-titles">Име:</span>
        <Input
          className="qr-user-form-input"
          name="firstName"
          label="firstName"
          placeholder="Име"
          value={user?.firstName}
          onChange={(e) => onRecordChange("firstName", e)}
        />
      </Form.Item>

      <Form.Item className="qr-user-form-item">
        <span className="qr-user-modal-field-titles">Фамилия:</span>
        <Input
          className="qr-user-form-input"
          name="lastName"
          label="lastName"
          placeholder="Фамилия"
          value={user?.lastName}
          onChange={(e) => onRecordChange("lastName", e)}
        />
      </Form.Item>
      {!toggleEditModal && (
        <Form.Item className="qr-user-form-item">
          <span className="qr-user-modal-field-titles">Email:</span>
          <Input
            className="qr-user-form-input"
            name="email"
            label="email"
            placeholder="email"
            value={user?.email}
            onChange={(e) => onRecordChange("email", e)}
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default QRUserForm;
